



















































import { Component, Vue, PropSync } from "vue-property-decorator";

@Component
export default class ConfirmDialog extends Vue {
  @PropSync("maxWidth", { default: 400 }) syncWidth!: number;
  dialog = false;
  resolve!: any;
  reject!: any;
  message: string | null = null;
  title: string | null = null;
  options = {
    color: "accentDarker110",
    width: 400,
    zIndex: 200,
    titleClasses: "px-6 pt-6 pb-5",
    noconfirm: false,
  };

  open(title: string, message: string, options: unknown): Promise<unknown> {
    this.dialog = true;
    this.title = title;
    this.message = message;
    this.options = Object.assign(this.options, options);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  confirm(): void {
    this.resolve(true);
    this.dialog = false;
  }

  cancel(): void {
    this.resolve(false);
    this.dialog = false;
  }
}
